import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import CookieBanner from "@/components/site/CookieBanner";

// Pages hors landing : chargées uniquement quand la route est visitée.
// Réduit le bundle initial de ~60 KiB (HelpCenter, ArticleDetail, etc.)
const HelpCenter = lazy(() => import("@/pages/HelpCenter"));
const ArticleDetail = lazy(() => import("@/pages/ArticleDetail"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const CGU = lazy(() => import("@/pages/CGU"));
const CGV = lazy(() => import("@/pages/CGV"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const NotFound = lazy(() => import("@/pages/NotFound"));
// Espaces de connexion : choix de la porte (TyCopro / TyCopro Manager) et présentation de Manager.
const Connexion = lazy(() => import("@/pages/Connexion"));
const OperateursCollectivites = lazy(() => import("@/pages/OperateursCollectivites"));
// « Ils nous font confiance » : partenaires et références, gérés depuis TyCopro Manager (espace plateforme).
const References = lazy(() => import("@/pages/References"));

// Outils gratuits (pages SEO publiques anonymes) — canal d'acquisition entrant.
const OutilsIndex = lazy(() => import("@/pages/outils/OutilsIndex"));
const GenerateurConvocation = lazy(() => import("@/pages/outils/GenerateurConvocation"));
const AideOrdreDuJour = lazy(() => import("@/pages/outils/AideOrdreDuJour"));
const GenerateurPV = lazy(() => import("@/pages/outils/GenerateurPV"));
const EcheancierConformite = lazy(() => import("@/pages/outils/EcheancierConformite"));
const DpeCollectifInfo = lazy(() => import("@/pages/outils/DpeCollectifInfo"));
const NoteConseilSyndical = lazy(() => import("@/pages/outils/NoteConseilSyndical"));

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Suspense fallback={null}>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/aide" element={<HelpCenter />} />
                        <Route path="/aide/:slug" element={<ArticleDetail />} />
                        <Route path="/mentions-legales" element={<LegalPage />} />
                        <Route path="/confidentialite" element={<PrivacyPolicy />} />
                        <Route path="/cookies" element={<CookiePolicy />} />
                        <Route path="/cgu" element={<CGU />} />
                        <Route path="/cgv" element={<CGV />} />
                        <Route path="/paiement/succes" element={<PaymentSuccess />} />
                        <Route path="/connexion" element={<Connexion />} />
                        {/* Habitude courante : « tycopro.fr/login ». Le site n'a pas de formulaire de
                            connexion — on mène au choix de l'espace (nginx répond déjà en 301). */}
                        <Route path="/login" element={<Navigate to="/connexion" replace />} />
                        <Route path="/operateurs-et-collectivites" element={<OperateursCollectivites />} />
                        <Route path="/partenaires-et-references" element={<References />} />
                        {/* Ancienne page d'attente supprimée : on redirige les liens périmés vers l'accueil. */}
                        <Route path="/app-bientot" element={<Navigate to="/" replace />} />
                        {/* Offre professionnelle retirée : les anciens liens renvoient vers l'accueil
                            (nginx répond déjà en 301 ; ceci couvre la navigation côté client). */}
                        <Route path="/professionnels" element={<Navigate to="/" replace />} />
                        <Route path="/outils" element={<OutilsIndex />} />
                        <Route path="/outils/generer-convocation-assemblee-generale" element={<GenerateurConvocation />} />
                        <Route path="/outils/ordre-du-jour-assemblee-generale-majorites" element={<AideOrdreDuJour />} />
                        <Route path="/outils/generer-proces-verbal-assemblee-generale" element={<GenerateurPV />} />
                        <Route path="/outils/ma-copropriete-est-elle-en-regle" element={<EcheancierConformite />} />
                        <Route path="/outils/dpe-collectif-copropriete" element={<DpeCollectifInfo />} />
                        <Route path="/outils/note-conseil-syndical-comparatif-cout" element={<NoteConseilSyndical />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Suspense>
                <CookieBanner />
            </BrowserRouter>
            <Toaster richColors position="top-center" />
        </div>
    );
}

export default App;
